<template>
  <div class="already-in-challenge-popup">
    <colored-popup
        class="primary"
        :darkText="false"
        :close-action="close">

      <template v-slot:top-content>
        <div class="title">מה הכינוי שבחרת לעצמך?</div>
      </template>

      <template v-slot:bottom-content>
        <plain-dropdown class="nickname-dropdown"
            :options="['', ...participantsNicknames]"
            :first-selected="''"
            :on-select="setNickname"
            variant="success">
        </plain-dropdown>
        <riseup-button title="התחבר" variant="primary" size="slim" :loading="loading" :action="goToDashboard"/>
      </template>
    </colored-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseUI from 'base-ui';

export default {
  name: 'AlreadyInChallengePopup',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    RiseupButton: BaseUI.RiseupButton,
    PlainDropdown: BaseUI.PlainDropdown,
  },
  data() {
    return {
      nickname: '',
    };
  },
  computed: {
    ...mapGetters('accountabilityChallenge', ['participantsNicknames']),
    ...mapState('accountabilityChallenge', ['loading']),
  },
  methods: {
    ...mapActions('modalRootStore', ['closeModal']),
    ...mapActions('accountabilityChallenge', ['setActiveParticipantByName', 'initChallengeDashboard']),
    close() {
      this.closeModal();
    },
    setNickname(nickname) {
      this.nickname = nickname;
    },
    async goToDashboard() {
      this.setActiveParticipantByName(this.nickname);
      await this.initChallengeDashboard();
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
.already-in-challenge-popup {
  .colored-top {
    .title {
      font-size: 22px;
      font-weight: bold;
      color: $riseup_white;
      text-align: right;
    }
  }
  .nickname-dropdown {
    margin-bottom: 40px;
  }
}
</style>
